/* Otheriver's original OR symbol, extruded locally without a 3D dependency.
 * Outline source: LOGO_OTHERIVER_DEF.svg, the logo configured in settings_data.json.
 * https://otheriver.com/cdn/shop/files/LOGO_OTHERIVER_DEF.svg?v=1784814759
 * These are the three original symbol outlines; the small signature and wordmark
 * belong to the flat lockup and are intentionally not part of the sculptural mark.
 */
(() => {
  'use strict';
  if (window.OtheriverImpactObject) return;

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const outlines = [
    'M1575.52 729.007C1764.59 722.277 1964.87 780.322 2122.78 883.902C2283.89 988.965 2411.67 1137.82 2491.11 1312.99C2507.96 1349.59 2529.93 1401.54 2538.03 1440.42C2488.03 1475.79 2309.26 1522.9 2243.28 1548.19C2210.64 1560.69 2167.66 1582.08 2136.27 1592.43C2124.32 1568.01 2116.13 1539.99 2103.88 1514.95C2006.46 1315.69 1808.28 1179.53 1581.7 1188.85C1432.05 1195.9 1291.12 1261.35 1189.18 1371.15C959.175 1619.99 997.056 2019.91 1274.43 2220.11C1392.44 2305.29 1510.29 2330.14 1653.64 2323.55C1697.63 2318.87 1741.09 2310.15 1783.48 2297.5C1802.79 2291.59 1832.03 2275.36 1849.14 2273.83C1857.79 2273.06 1878.72 2324.33 1883.71 2334.11C1923.73 2412.54 1977.41 2482.37 2035.55 2548.12C2056.57 2571.89 2080.15 2593.38 2101.38 2616.73C2089.33 2626.26 2059.63 2641.91 2044.93 2649.58C1931.53 2707.73 1807.55 2742.35 1680.44 2751.38C1612.56 2755.57 1540.46 2755.34 1472.93 2747.22C997.346 2690.03 633.945 2288.26 604.974 1813.89C586.49 1537.4 680.94 1265.24 866.725 1059.64C1006.72 902.621 1193.03 794.206 1398.71 750.071C1461.38 736.978 1512.03 732.798 1575.52 729.007Z',
    'M2624.37 1592.59C2632.9 1595.55 2634.01 1601.01 2640.69 1606.59C2710.83 1650.37 2786.87 1692.07 2855.32 1736.18C2827.05 1744.57 2797.64 1755.25 2768.85 1763.58C2685.64 1787.66 2552.78 1823.23 2498.88 1894.47C2475.98 1924.43 2466.35 1962.46 2472.25 1999.7C2479.46 2047.89 2509.63 2083.54 2541.65 2118.29C2638.23 2223.09 2755.13 2306.43 2870.1 2389.57C2980.55 2469.24 3091.52 2548.2 3203 2626.43C3256.44 2663.74 3318.74 2703.86 3370.38 2742.06C3246.82 2744.76 3111.93 2741.88 2987.46 2741.9C2821.14 2743.41 2654.8 2743.57 2488.48 2742.37C2431.66 2696.41 2376.02 2649.01 2321.61 2600.23C2155.91 2452.89 1867.63 2179.6 1984.9 1928.16C2074.01 1737.11 2336.64 1683.17 2517.96 1628.35C2554 1617.45 2588.52 1605.7 2624.37 1592.59Z',
    'M2159.62 740.027C2241.25 738.412 2330.15 738.603 2411.75 739.905C2496.65 741.26 2651.11 730.288 2727.39 755.369C2769.33 767.691 2797.93 773.854 2840.07 792.139C3203.54 949.866 3350.55 1479.11 2954.15 1694.62C2939.79 1702.43 2910.8 1717.87 2895 1720.67C2889.43 1726.14 2864.05 1733.62 2855.32 1736.18C2786.87 1692.07 2710.83 1650.37 2640.69 1606.59C2634.01 1601.01 2632.9 1595.55 2624.37 1592.59L2631.65 1589.72C2681.57 1570.22 2733.22 1546.96 2774.69 1512.6C2829.45 1466.78 2863.9 1401.2 2870.54 1330.11C2876.51 1258.67 2853.98 1187.78 2807.89 1132.88C2751.91 1066.88 2669.92 1029.28 2584.24 1026.51C2549.11 1025.37 2511.15 1026.94 2476.79 1024.26C2467.43 1015.74 2454.03 998.335 2445.4 988.021C2431.02 970.662 2415.83 953.981 2399.9 938.033C2342.48 880.497 2278.82 828.546 2208.06 788.175C2179.08 771.636 2146.01 756.742 2115.94 740.936C2129.86 740.045 2145.53 740.191 2159.62 740.027Z'
  ];

  // The original paths use only absolute M, L and C commands. Sampling the
  // Béziers once keeps rendering small and works without inserting an SVG node.
  function sampleOutline(path) {
    const tokens = path.match(/[MLCZ]|-?\d*\.?\d+/g);
    const points = [];
    let position = [0, 0], index = 0;
    while (index < tokens.length) {
      const command = tokens[index++];
      if (command === 'M' || command === 'L') {
        position = [Number(tokens[index++]), Number(tokens[index++])];
        points.push(position);
      } else if (command === 'C') {
        const start = position;
        const a = [Number(tokens[index++]), Number(tokens[index++])];
        const b = [Number(tokens[index++]), Number(tokens[index++])];
        const end = [Number(tokens[index++]), Number(tokens[index++])];
        const length = Math.hypot(a[0] - start[0], a[1] - start[1]) + Math.hypot(b[0] - a[0], b[1] - a[1]) + Math.hypot(end[0] - b[0], end[1] - b[1]);
        const segments = Math.max(3, Math.ceil(length / 18));
        for (let step = 1; step <= segments; step++) {
          const t = step / segments, u = 1 - t;
          points.push([0, 1].map(axis => u * u * u * start[axis] + 3 * u * u * t * a[axis] + 3 * u * t * t * b[axis] + t * t * t * end[axis]));
        }
        position = end;
      }
    }
    return points.map(([x, y]) => [(x - 1980) / 900, (y - 1743) / 900]);
  }
  const shapes = outlines.map(sampleOutline);
  const transform = (point, cx, sx, cy, sy, cz, sz) => {
    const x = point[0] * cy + point[2] * sy;
    const z = -point[0] * sy + point[2] * cy;
    const y = point[1] * cx - z * sx;
    return [x * cz - y * sz, x * sz + y * cz, point[1] * sx + z * cx];
  };

  function mount(canvas) {
    const noop = { destroy() {}, pause() {}, resume() {} };
    if (!canvas || typeof canvas.getContext !== 'function') return noop;
    if (canvas.__otheriverImpactObject) return canvas.__otheriverImpactObject;
    const context = canvas.getContext('2d', { alpha: true });
    if (!context) return noop;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const pointerSurface = canvas.closest('.oi-hero') || canvas.closest('.oi-object') || canvas;
    let width = 1, height = 1, ratio = 1, frame = 0;
    let disposed = false, paused = false, visible = true;
    let lastFrame = 0, progress = 0, scrollProgress = 0;
    let pointerX = 0, pointerY = 0, rotationX = 0, rotationY = 0;

    function render() {
      if (disposed || width < 2 || height < 2) return;
      context.setTransform(ratio, 0, 0, ratio, 0, 0);
      context.clearRect(0, 0, width, height);
      const size = Math.min(width, height), scale = size * .265;
      const animated = !motion.matches;
      // Bounded angles preserve the recognisable OR silhouette, even on touch.
      const tilt = -.12 + rotationY * .18 + (animated ? Math.sin(progress * .65) * .065 : 0);
      const turn = -.29 + rotationX * .29 + (animated ? Math.sin(progress * .44) * .14 + scrollProgress * .32 : 0);
      const spin = -.09 + (animated ? Math.sin(progress * .32) * .035 - scrollProgress * .05 : 0);
      const cx = Math.cos(tilt), sx = Math.sin(tilt), cy = Math.cos(turn), sy = Math.sin(turn), cz = Math.cos(spin), sz = Math.sin(spin);
      const float = animated ? Math.sin(progress * .8) * size * .009 : 0;
      const project = point => {
        const p = transform(point, cx, sx, cy, sy, cz, sz);
        const perspective = 7 / (7 - p[2]);
        return { x: width * .5 + p[0] * scale * perspective, y: height * .5 + p[1] * scale * perspective + float, z: p[2] };
      };
      const halo = context.createRadialGradient(width * .51, height * .52, 0, width * .51, height * .52, size * .48);
      halo.addColorStop(0, 'rgba(167,199,90,.06)');
      halo.addColorStop(.7, 'rgba(17,39,63,.04)');
      halo.addColorStop(1, 'rgba(17,39,63,0)');
      context.fillStyle = halo;
      context.fillRect(0, 0, width, height);

      const trace = points => {
        context.beginPath();
        points.forEach((p, i) => i ? context.lineTo(p.x, p.y) : context.moveTo(p.x, p.y));
        context.closePath();
      };
      const components = shapes.map((shape, index) => ({
        index,
        front: shape.map(([x, y]) => project([x, y, .20])),
        back: shape.map(([x, y]) => project([x, y, -.20]))
      }));

      // Cast shadow and a navy back plate establish depth without glow washout.
      context.save();
      context.shadowColor = 'rgba(0,5,14,.3)';
      context.shadowBlur = size * .035;
      context.shadowOffsetY = size * .024;
      context.fillStyle = '#031122';
      components.forEach(component => { trace(component.back); context.fill(); });
      context.restore();

      const sides = [];
      components.forEach(component => {
        const { front, back, index } = component;
        for (let i = 0; i < front.length; i++) {
          const next = (i + 1) % front.length;
          const points = [back[i], back[next], front[next], front[i]];
          sides.push({ points, index, depth: points.reduce((sum, p) => sum + p.z, 0) / 4, light: (front[next].y - front[i].y) / (Math.hypot(front[next].x - front[i].x, front[next].y - front[i].y) || 1) });
        }
      });
      sides.sort((a, b) => a.depth - b.depth);
      context.lineWidth = .55;
      context.lineJoin = 'round';
      sides.forEach(side => {
        const light = (side.light + 1) * .5;
        const color = side.index === 2
          ? `rgb(${Math.round(39 + light * 46)},${Math.round(52 + light * 55)},${Math.round(13 + light * 20)})`
          : `rgb(${Math.round(7 + light * 26)},${Math.round(23 + light * 36)},${Math.round(42 + light * 42)})`;
        context.fillStyle = color;
        context.strokeStyle = color;
        trace(side.points); context.fill(); context.stroke();
      });

      // The three front faces retain the exact original outlines. The R crown
      // carries the approved lime accent; the rest reflects a soft silver light.
      components.sort((a, b) => a.front.reduce((s, p) => s + p.z, 0) / a.front.length - b.front.reduce((s, p) => s + p.z, 0) / b.front.length);
      components.forEach(component => {
        const sheen = context.createLinearGradient(width * (.15 + rotationX * .10), height * .14, width * .83, height * .86);
        const colors = component.index === 2
          ? ['#f0ffb8', '#d1ee79', '#f1ffbd', '#a6c94d', '#cae77a']
          : ['#edf5f5', '#9faebb', '#f6fbf5', '#8497a6', '#d7e5e4'];
        [0, .30, .46, .67, 1].forEach((stop, i) => sheen.addColorStop(stop, colors[i]));
        trace(component.front);
        context.fillStyle = sheen;
        context.fill();
        context.strokeStyle = component.index === 2 ? 'rgba(238,255,184,.72)' : 'rgba(239,252,250,.65)';
        context.lineWidth = Math.max(.8, size * .0015);
        context.stroke();
      });
      canvas.dataset.objectReady = 'true';
      canvas.dataset.objectGeometry = 'otheriver-logo';
    }

    function tick(now) {
      frame = 0;
      if (disposed || paused || !visible || document.hidden || motion.matches) return;
      const elapsed = now - lastFrame;
      if (!lastFrame || elapsed >= (width < 600 ? 40 : 32)) {
        const delta = lastFrame ? Math.min(100, elapsed) / 1000 : 0;
        lastFrame = now;
        progress += delta;
        const smoothing = 1 - Math.exp(-delta * 7);
        rotationX += (pointerX - rotationX) * smoothing;
        rotationY += (pointerY - rotationY) * smoothing;
        render();
      }
      frame = window.requestAnimationFrame(tick);
    }
    function wake() {
      if (disposed || paused || !visible || document.hidden || motion.matches || frame) return;
      lastFrame = 0;
      frame = window.requestAnimationFrame(tick);
    }
    function stop() { window.cancelAnimationFrame(frame); frame = 0; lastFrame = 0; }
    function resize() {
      if (disposed) return;
      const rect = canvas.getBoundingClientRect();
      width = Math.max(1, rect.width); height = Math.max(1, rect.height);
      ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(width * ratio); canvas.height = Math.round(height * ratio);
      render(); wake();
    }
    function pointer(event) {
      if (motion.matches) return;
      const rect = pointerSurface.getBoundingClientRect();
      pointerX = clamp((event.clientX - rect.left) / Math.max(1, rect.width) * 2 - 1, -1, 1);
      pointerY = clamp((event.clientY - rect.top) / Math.max(1, rect.height) * 2 - 1, -1, 1);
      wake();
    }
    function leave() { pointerX = 0; pointerY = 0; }
    function scroll() {
      if (motion.matches || !visible) return;
      const rect = pointerSurface.getBoundingClientRect();
      scrollProgress = clamp(-rect.top / Math.max(1, rect.height), -.25, 1);
      wake();
    }
    function pause() { paused = true; stop(); }
    function resume() { paused = false; wake(); }
    function reducedMotion() {
      stop();
      if (motion.matches) { rotationX = 0; rotationY = 0; render(); }
      else { scroll(); wake(); }
    }
    function visibility() { if (document.hidden) stop(); else wake(); }
    const resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(canvas);
    const intersectionObserver = new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? true;
      if (!visible) stop(); else { scroll(); wake(); }
    }, { threshold: .01 });
    intersectionObserver.observe(canvas);
    pointerSurface.addEventListener('pointermove', pointer, { passive: true });
    pointerSurface.addEventListener('pointerdown', pointer, { passive: true });
    pointerSurface.addEventListener('pointerup', leave, { passive: true });
    pointerSurface.addEventListener('pointercancel', leave, { passive: true });
    pointerSurface.addEventListener('pointerleave', leave, { passive: true });
    window.addEventListener('scroll', scroll, { passive: true });
    document.addEventListener('visibilitychange', visibility);
    motion.addEventListener('change', reducedMotion);
    resize();

    function destroy() {
      disposed = true; stop();
      resizeObserver.disconnect(); intersectionObserver.disconnect();
      pointerSurface.removeEventListener('pointermove', pointer);
      pointerSurface.removeEventListener('pointerdown', pointer);
      pointerSurface.removeEventListener('pointerup', leave);
      pointerSurface.removeEventListener('pointercancel', leave);
      pointerSurface.removeEventListener('pointerleave', leave);
      window.removeEventListener('scroll', scroll);
      document.removeEventListener('visibilitychange', visibility);
      motion.removeEventListener('change', reducedMotion);
      delete canvas.__otheriverImpactObject;
    }
    const instance = { destroy, pause, resume };
    canvas.__otheriverImpactObject = instance;
    return instance;
  }
  window.OtheriverImpactObject = { mount };
})();
